import type { ReactNode } from "react";

import { AuthProvider, useAuth } from "./auth/AuthContext.js";
import { Login } from "./pages/Login.js";
import { Mail } from "./pages/Mail.js";

/**
 * Twee toestanden, dus geen router: ingelogd of niet. Een adresbalk met paden
 * zou bij deze app alleen maar deelbare URL's naar andermans mailbox suggereren.
 */
function Routes(): ReactNode {
  const { status } = useAuth();

  // Zolang we het sessiecookie natrekken tonen we niets: een loginformulier dat
  // meteen weer verdwijnt leert de gebruiker zijn wachtwoord te snel intikken.
  if (status === "checking") return <div className="boot" aria-busy="true" />;
  return status === "authenticated" ? <Mail /> : <Login />;
}

export default function App(): ReactNode {
  return (
    <AuthProvider>
      <Routes />
    </AuthProvider>
  );
}
